module.exports = __webpack_public_path__ + "static/img/bg.0a31126.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/list/bg.jpg
// module id = Px+/
// module chunks = 1